<div class="page">
  @if (initialized()) {
    @if (data() && data().magazine) {
      <div class="container-fluid container-site fade-in pt-4 pt-lg-5">
        <!-- Header -->
        <div class="row mb-4 mb-lg-5">
          @if (data().magazine?.cover) {
            <div class="col-md-6 text-center fade-in">
              <div class="d-inline-block">
                <img
                  [src]="data().magazine?.cover | assetFormatter"
                  class="img-fluid"
                  [alt]="data().magazine?.title"
                />
              </div>
            </div>
          }

          <div class="col-md-6 d-flex align-items-start flex-column">
            <div class="row mb-4">
              <div class="col-12">
                <div class="liber-number h2 mb-0">
                  <div>
                    <p class="h1 font-monospace text-olive mb-0">Liber</p>
                  </div>

                  <div class="liber-number-circle">
                    {{ data().magazine!.number }}
                  </div>

                  <div>
                    <img
                      src="/img/logo-ac-sm.webp"
                      height="40"
                      alt="Arte y Cultura"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="pb-2 mt-auto">
              <div class="row gy-3">
                <div class="col-12">
                  <p class="h3 fw-bold mb-0">Editorial</p>
                </div>

                <div class="col-12">
                  @if (data().editorial?.content) {
                    @if (data().editorial?.content!.length > 600) {
                      <div
                        [innerHTML]="
                          data().editorial?.content.slice(0, 600) + '...'
                        "
                      ></div>
                    } @else {
                      <div [innerHTML]="data().editorial?.content"></div>
                    }
                  }
                </div>

                <div class="col-md-auto">
                  <a
                    class="btn btn-gray btn-min"
                    [routerLink]="['/articulo', data().editorial?.slug]"
                  >
                    Seguir leyendo
                  </a>
                </div>

                @if (data().magazine?.pdf && data().magazine!.pdf.length > 0) {
                  <div class="col-md-auto">
                    <a
                      [href]="
                        data().magazine!.pdf[0].download_link | assetFormatter
                      "
                      class="btn btn-primary btn-min"
                      target="_blank"
                      rel="noopener"
                    >
                      Ver Liber en PDF
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-4 gy-4">
          <div class="col-12">
            <p class="h4 text-center mb-0">Contenido</p>
          </div>

          <app-content [items]="data().articles"></app-content>
        </div>

        <div class="row my-4 my-lg-5 gy-4">
          <div class="col-12">
            <p class="h3 text-center mb-4">
              Archivo de la revista digital Liber
            </p>
          </div>

          @for (item of data().magazines; track $index) {
            <div class="col-sm-6 col-md-4 col-lg-3">
              <div class="magazine-item">
                <div class="row w-100 gy-3 py-3">
                  <div class="col-12">
                    <p class="h5 text-olive font-monospace fw-normal">
                      {{ item.title }}
                    </p>
                  </div>

                  <div class="col-12">
                    <img
                      [src]="item.cover | assetFormatter"
                      class="img-fluid"
                      [alt]="item.title"
                    />
                  </div>

                  <div class="col-12 text-center">
                    <button
                      type="button"
                      class="btn btn-light btn-md"
                      [routerLink]="['/liber', item.slug]"
                    >
                      Ver todo el contenido
                    </button>
                  </div>

                  @if (item.pdf && item.pdf.length > 0) {
                    <div class="col-12 text-center">
                      <a
                        [href]="item.pdf[0].download_link | assetFormatter"
                        class="btn btn-primary btn-md"
                        target="_blank"
                        rel="noopener"
                      >
                        Ver Liber en PDF
                      </a>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  } @else {
    <app-spinner></app-spinner>
  }
</div>
